import { render, staticRenderFns } from "./InquiryRequestView.vue?vue&type=template&id=077769ea&scoped=true"
import script from "./InquiryRequestView.vue?vue&type=script&lang=js"
export * from "./InquiryRequestView.vue?vue&type=script&lang=js"
import style0 from "./InquiryRequestView.vue?vue&type=style&index=0&id=077769ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "077769ea",
  null
  
)

export default component.exports